module.exports = __webpack_public_path__ + "static/img/gzh.e9c8e10a.jpg";